import React, { useEffect, useState } from 'react';

const NotFound = () => {

  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);

  if (!loaded) {
    return <div className={`11`}></div>; // 或者显示一个加载状态
  }

  return (
    <div style={{height: '100vh', display: 'flex', 'flexDirection': 'column', justifyContent: 'center', alignItems: 'center'}}>
      <h1>404 - 页面未找到</h1>
      <p style={{margin: '0.3rem 0 0'}}>抱歉，你访问的页面不存在。</p>
    </div>
  );
};

export default NotFound;